export default function LoadingWheel() {
    return(<div>Loading...</div>);
}